<template>
  <CHeader fixed with-subheader light>
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img class="icon" alt="Aeru_logo" src="../assets/icons/logo2.png" width="100">
    </CHeaderBrand>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>

export default {
  name: 'TheHeader',
  components: {
  }
}
</script>
